<template>
<div class="audit-vocs-related-chart-group">
  <div v-for="(data, index) in dataGroup" :key="index">
    <related-chart
      :base-data="data[0]"
      :related-data="data[1]"
      :audit-rule-map="auditRuleFlagMap"
    />
  </div>
</div>
</template>

<script>
import BaseCompare from './BaseCompare'
import {mapGetters} from 'vuex'

import RelatedChart from '../../../../components/Data/RelatedChart'

export default {
  name: 'VocsRelatedChart',
  extends: BaseCompare,
  components: {RelatedChart},
  props: {
    auditDataList: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    unitProp: 'stdUnit',
    dataGroup: Object.freeze([])
  }),
  computed: {
    valueProp: () => 'autoValue',
    ...mapGetters({
      relatedFactors: 'Factor/relatedFactors',
      auditRuleFlagMap: 'AuditRule/flagMap'
    }),
    relatedOpts () {
      let {filterFactorMap} = this

      return this.relatedFactors.reduce((list, relatedFactorConfig) => {
        let {factorId} = relatedFactorConfig
        let factor = filterFactorMap[factorId]

        if (factor) {
          let {relatedFactorId} = relatedFactorConfig
          let relatedFactor = filterFactorMap[relatedFactorId]

          if (relatedFactor) {
            list.push({
              value: `${factorId}-${relatedFactorId}`,
              label: `${factor.name} VS ${relatedFactor.name}`,
              id1: factorId,
              id2: relatedFactorId,
              relatedHigh: relatedFactorConfig.relatedHigh,
              relatedLow: relatedFactorConfig.relatedLow
            })
          }
        }

        return list
      }, [])
    }
  },
  methods: {
    filterCurrentSiteDeviceFactors (siteDeviceFactors) {
      let siteDeviceFactorMap = siteDeviceFactors.reduce((map, siteDeviceFactor) => {
        map[siteDeviceFactor.factorId] = siteDeviceFactor
        return map
      }, {})

      return this.relatedFactors.reduce((list, relatedFactor) => {
        let {factorId} = relatedFactor
        let factor = siteDeviceFactorMap[factorId]

        if (factor) {
          let {relatedFactorId} = relatedFactor
          let relatedValueFactor = siteDeviceFactorMap[relatedFactorId]

          if (relatedValueFactor) {
            list.push(factor, relatedValueFactor)
          }
        }

        return list
      }, [])
    },
    getData () {

    },
    getSeriesParam (dimension, dimensionIds) {
      return null
    },
    setDataGroup () {
      let [dataConfig] = this.dataList
      let dimensionMap = dataConfig.dimensions.reduce((map, dimension) => {
        map[dimension.id] = dimension
        return map
      }, {})
      let {dataTimes, seriesMap} = dataConfig
      let {unitProp} = this

      this.dataGroup = Object.freeze(this.relatedOpts.map(({id1, id2, relatedLow, relatedHigh}) => [id1, id2].map(dimensionId => {
        let dimension = dimensionMap[dimensionId]
        let series = seriesMap[dimensionId]

        return {
          id: dimensionId,
          name: dimension.name,
          unit: dimension[unitProp],
          relatedLow,
          relatedHigh,
          data: dataTimes.map(dataTimeObj => {
            let dataTime = dataTimeObj[1]
            let data = series[dataTime]
            return data || {
              dataTime,
              value: null
            }
          })
        }
      })))
    }
  },
  watch: {
    auditDataList: {
      immediate: true,
      handler (auditDataList) {
        clearTimeout(this.setDataListTimer)
        this.setDataListTimer = setTimeout(() => {
          this.setDataList(auditDataList)
          this.setDataGroup()
        }, 0)
      }
    }
  }
}
</script>

<style lang="scss">
.audit-vocs-related-chart-group {
  --related-chart-width: 350px;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 10px;
  width: 100%;
  height: 100%;
  padding: 12px 0;
  border: 1px solid rgb(228, 231, 237);
  overflow: auto;

  > div {
    flex: 0 0 var(--related-chart-width);
    min: {
      width: 0;
      height: 0;
    }
    height: var(--related-chart-width);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/VocsRelatedChart.vue